import React from 'react';
// import CircularProgress, { LinearProgressProps } from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';


export default function LoadingControl(props: LinearProgressProps & { message: string }) {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress {...props} />
            </Box>
            <Box minWidth={100}>
                <Typography variant="body2" color="textSecondary">{props.message}</Typography>
            </Box>
        </Box>
    );
}